// FOS-SOURCE-PICKER-KEYBOARD-001 (WI-589, Rob 2026-09-30): one list of stores and
// websites for every "Where did it come from?" question, so people tap instead of
// type and the saved names match ("Macy's", never "macys" and "Macys" as three
// different stores). Anything not on the list is typed under Other and kept as typed.
//
// To add a store, add it here once; every picker in the app uses this list.

export const SOURCE_GROUPS = Object.freeze([
  Object.freeze({
    label: 'Stores',
    names: Object.freeze([
      'Belk', "Bloomingdale's", 'Burlington', 'Costco', "Dillard's", 'JCPenney', "Kohl's", "Macy's",
      'Marshalls', 'Neiman Marcus', 'Nordstrom', 'Nordstrom Rack', 'Perfumania', 'Ross', 'Saks Fifth Avenue',
      'Saks Off 5th', "Sam's Club", 'Sephora', 'Target', 'TJ Maxx', 'Ulta Beauty', 'Walmart',
      'Brand boutique', 'Duty free / airport', 'Local shop',
    ]),
  }),
  Object.freeze({
    label: 'Online & resale',
    names: Object.freeze([
      'Amazon', 'eBay', 'Facebook Marketplace', 'FragranceNet', 'FragranceX', 'Jomashop', 'Luckyscent',
      'MaxAroma', 'Mercari', 'Notino', 'Poshmark', 'TikTok Shop', 'Twisted Lily', 'Brand website',
    ]),
  }),
])

export const SOURCE_NAMES = Object.freeze(SOURCE_GROUPS.flatMap(group => group.names))

// "macys", "Macys" and "MACY'S" all mean Macy's; spacing, case and punctuation never
// make a different store.
const keyOf = text => String(text ?? '').toLowerCase().replace(/[^a-z0-9]/g, '')
const BY_KEY = new Map(SOURCE_NAMES.map(name => [keyOf(name), name]))

// The listed spelling when the text names a listed store, otherwise null.
export function listedSource(text) {
  const key = keyOf(text)
  return key ? BY_KEY.get(key) ?? null : null
}

// What to save: the listed spelling when there is one, otherwise the trimmed text
// exactly as typed, or null when empty.
export function canonicalSourceName(text) {
  const trimmed = typeof text === 'string' ? text.trim() : ''
  if (!trimmed) return null
  return listedSource(trimmed) ?? trimmed
}
